import { SmsMessageDto } from 'actions/twoWaySms/twoWaySmsDtos';
import { PhoneSearchType } from 'model/PhoneSearch';

export interface ProspectMessageDto {
    id: number | undefined;
    uuid?: string;
    marketplace_id: number;
    prospect_id: number;
    sender_id: number;
    sender_type: ActorType;
    receiver_id: number;
    receiver_type: ActorType;
    message: string;
    sent_at?: Date;
    received_at?: Date;
    read_at?: Date;
    updated_at?: Date;
    created_at?: Date;
}

export enum ActorType {
    PROSPECT = 'Prospect',
    MARKETPLACE = 'Marketplace'
}

export interface MetaDto {
    current_page: number;
    per_page: number;
    total_entries: number;
    total_pages: number;
}

export interface ProspectDto {
    id: number;
    uuid?: string;
    phone: string;
}

export interface ProspectConversationsDto {
    prospect_conversations: Array<ProspectConversationDto>;
    meta: MetaDto;
}

export interface ProspectConversationDto {
    prospect: ProspectDto;
    total_message: number;
    unread_messages: number;
    last_message: ProspectMessageDto;
}

export interface ProspectChatDto {
    prospect: ProspectDto;
    unread_messages: number;
    last_message: ProspectMessageDto;
    messages: Array<ProspectMessageDto>;
    meta: MetaDto;
}

export interface MessageDto {
    id: number;
    phone: string;
    type: PhoneSearchType;
    message: ProspectMessageDto | SmsMessageDto;
}
